import { SliderDrag as SliderDragCore } from '@studiometa/ui';

export default class SliderDrag extends SliderDragCore {
  onStart() {
    this.$el.classList.add('is-dragging');
    this.$parent.$children.SliderItem.forEach((item) => item.disactivate());
  }

  onDrop() {
    this.$el.classList.remove('is-dragging');
  }
}
